package com.loyola.acessoescola.ui.policy

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.back
import acessoescola.composeapp.generated.resources.check_24px
import acessoescola.composeapp.generated.resources.privacy_policy_content
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.loyola.acessoescola.ui.theme.AcessoEscolaTheme
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource


@Composable
fun PolicyScreen(
    paddingValues: PaddingValues,
    navigateBack: () -> Unit,
) {
    Scaffold(
        floatingActionButton = {
            FloatingActionButton(
                onClick = {navigateBack()},
            ) {
                Icon(
                    imageVector = vectorResource(Res.drawable.check_24px),
                    contentDescription = stringResource(Res.string.back)
                )
            }
        },
        modifier = Modifier.padding(paddingValues)
    ) {
        Column(
            modifier = Modifier.verticalScroll(rememberScrollState())
                .padding(horizontal = 12.dp)
        ) {
            Text(
                text = stringResource(Res.string.privacy_policy_content),
                textAlign = TextAlign.Center
            )
        }
    }
}

@Preview
@Composable
private fun PolicyScreenPreview() {
    AcessoEscolaTheme {
        PolicyScreen(
            paddingValues = PaddingValues(0.dp),
            navigateBack = {}
        )
    }
}